

import Vue from 'vue'
import Component from "vue-class-component";
import {namespace} from "vuex-class";
import UserSearch from "@/components/user/widget/UserSearch.vue";
import {IShortUser} from "@/model/shortInterfaces";
import {ICommunicationMessage} from "@/model/Communication/ICommunicationMessage";
import CommunicationMessages from "@/components/communications/widget/CommunicationMessages.vue";
import UserNav from "@/components/user/widget/UserNav.vue";
import {BoListPanel} from "bonomo";
import {IAuthUserData} from "@/store/modules/authModule";

const userModule = namespace("userModule");
const authModule = namespace("authModule");
const userPermissionModule = namespace("userPermissionModule");

@Component({
  name: 'UserCommunications',
  components: {
    BoListPanel,
    CommunicationMessages,
    UserSearch,
    UserNav,
  }
})
export default class UserCommunications extends Vue {

  protected loading: boolean = true;

  @userModule.Getter('communications')
  private communications!: ICommunicationMessage[];

  @userModule.Action('fetchCommunications')
  protected fetchCommunications!: () => Promise<any>;

  @authModule.Getter('userData')
  protected authUser!: IAuthUserData;

  @userPermissionModule.Getter('permissionsUser')
  protected user!: IAuthUserData;

  @userPermissionModule.Action('fetchPermissionsUser')
  protected fetchPermissionsUser!: (userId: number) => Promise<any>;

  get isSelf() {
    return '' + this.$route.params.userId === '' + this.authUser.id;
  }

  get userId(): number {
    return parseInt(this.$route.params.userId);
  }
  // pass this.userId inside the filters, so we don't have to inject userId into calling fetchCommunications()
  //  (which we would do with a proxy function instead of this getter). Also the store has a single param now
  get extraFilters(): any {
    return {
      userId: this.userId,
    }
  }

  private loadData() {
    this.fetchPermissionsUser(this.userId as number);
  }

  private gotoUser(user: IShortUser) {
    this.$router.push({name: 'userCommunications', params: {userId: ''+user.id}});
  }

}

